import React from 'react';
import styles from './FCCMDashboard.css';
import smartlookClient from 'smartlook-client';
import {Link, Route, BrowserRouter as Router, Routes, Navigate} from 'react-router-dom';
import {HeaderContext, Nav} from '@deere/ux.uxframe-react';
import Container from '@material-ui/core/Container';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import PowerSettingsNewIcon from '@material-ui/icons/PowerSettingsNew';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import PaperSwitch from '@material-ui/core/Switch';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Grid from '@material-ui/core/Grid';
import {DeereLogo} from './DeereLogo';
import {AdminPage} from './AdminPage';
import {AlfaUser} from './AlfaUser';
import {SelectProposalEsign} from './ESignature/SelectProposalEsign';
import {config} from '../shared/config';
import {auth, AuthService} from '../services/auth';
import {createTheme, ThemeProvider} from '@material-ui/core/styles';
import '@deere/ux.uxframe-core/dist/css/uxframe.min.css';
import DeereFooter from './DeereFooter';
import history from '../shared/history';
import {DealerMerge} from './DealerMerge';
import {hasAccessToEsignatureModule, hasAccessToProposalTrackingModule} from '../shared/accessGroups';
import {FormattedMessage} from 'react-intl';
import {TranslationWrapper} from './Translation/TranslationWrapper';
import TranslateTab from './Navigation/TranslateTab';
import Smartlook from './Smartlook';
import {EmptyStateLayout} from './ESignature/EmptyPage';
import AdminUtility from './AdminUtility';
import {SearchPage} from './SearchPage';
import EnvelopeWithLocation from './ESignature/Envelope/envelopWithLocation';

const theme = createTheme({
    palette: {
        primary: {
            main: '#367C2B'
        },
        secondary: {
            main: '#FFF'
        }
    }
});


export class FCCMDashboard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            idTokenUser: auth.config.providers[0].idToken.user,
            user: null,
            role: null,
            activeMenu: window.location.pathname.split('/')[1],
            searchParam: history.location.search.split('=')[1],
            branchCode: 'UK'
        };
        this.logoutApplication = this.logoutApplication.bind(this);
    }

    static contextType = HeaderContext;

    async componentDidMount() {
        this.setState({
            loading: true
        });
        const name = this.state.idTokenUser.given_name;
        const user_domainName = this.state.idTokenUser.preferred_username;
        smartlookClient.identify(name, {
            'userName': name,
            'user_domainName': user_domainName
        });
        try {
            const promises = [];
            promises.push(AuthService.user);
            const [user] = await Promise.all(promises);
            this.setState({
                user,
                role: AuthService.role,
                branchCode: user.branchCode
            });
        } finally {
            this.setState({
                loading: false
            });
        }
    }

    translateToEnglishSwitchHandler = (branchCode) => {
        this.setState({ branchCode })
    }

    logoutApplication() {
        AuthService.logout(auth.config.providers[0].name);
    }

    render() {
        return (
            <TranslationWrapper branchCode={this.state.branchCode}>
                <ThemeProvider theme={theme}>
                    <Smartlook />
                    <Router history={history}>
                        <AppBar color="secondary" position="sticky">
                            <Toolbar>
                                <DeereLogo bars style={{ marginLeft: -24 }} />
                                <div className="uxf-header-title" style={{ marginRight: 10 }}>
                                    <span className="h1 uxf-header-title-heading">
                                        <a className="uxf-header-title-link" href="/">FC Utilities</a>
                                    </span>
                                    <p className={styles.logout} onClick={this.logoutApplication}>
                                        <FormattedMessage id={'labels.HI'} />, {this.state.idTokenUser.given_name}
                                        <span><PowerSettingsNewIcon fontSize="small" /></span>
                                    </p>
                                </div>
                            </Toolbar>
                            <Grid alignItems="center" className={styles.navbar} container justifyContent="flex-start">
                                {(this.state.user !== null
                                    && hasAccessToProposalTrackingModule.includes(this.state.user.branchCode))
                                && <Nav.Item onClick={() => this.setState({ activeMenu: 'proposal-tracking' })}>
                                    <Nav.Link
                                        as={Link}
                                        className={this.state.activeMenu === 'proposal-tracking' ? styles.menuItemActive : 'uxf-link-text'}
                                        to="/proposal-tracking">
                                        <FormattedMessage id={'labels.PROPOSAL_TRACKING'} />
                                    </Nav.Link>
                                </Nav.Item>}
                                {(this.state.user !== null
                                    && hasAccessToEsignatureModule.includes(this.state.user.branchCode))
                                && <Nav.Item onClick={() => this.setState({ activeMenu: 'e-sign' })}>
                                    <Nav.Link
                                        as={Link}
                                        className={this.state.activeMenu === 'e-sign' ? styles.menuItemActive : 'uxf-link-text'}
                                        to="/e-sign">
                                        <FormattedMessage id={'labels.E_SIGNATURE'} />
                                    </Nav.Link>
                                </Nav.Item>}
                                {(this.state.user && this.state.user.hasAccessToMergerAndAcquisition)
                                && <Nav.Item onClick={() => this.setState({ activeMenu: 'merge-dealers' })}>
                                    <Nav.Link
                                        as={Link}
                                        className={this.state.activeMenu === 'merge-dealers' ? styles.menuItemActive : 'uxf-link-text'}
                                        to="/merge-dealers">
                                        <FormattedMessage id={'labels.MERGER_AND_ACQUISITION'} />
                                    </Nav.Link>
                                </Nav.Item>}
                                {(this.state.user && this.state.user.hasAccessToFCCMAdminUtility)
                                    && <Nav.Item onClick={() => this.setState({ activeMenu: 'admin-utility' })}>
                                        <Nav.Link
                                            as={Link}
                                            className={this.state.activeMenu === 'admin-utility' ? styles.menuItemActive : 'uxf-link-text'}
                                            to="/admin-utility">
                                            <FormattedMessage id={'labels.ADMIN_UTILITY'} />
                                        </Nav.Link>
                                    </Nav.Item>}
                                {this.state.user && this.state.user.role === 'ADMIN' && (
                                    <Nav.Item onClick={() => this.setState({ activeMenu: 'alfauser' })}>
                                        <Nav.Link as={Link}
                                            className={this.state.activeMenu === 'alfauser' ? styles.menuItemActive : 'uxf-link-text'}
                                            to="/alfauser">FC User</Nav.Link>
                                    </Nav.Item>)}
                                {this.state.user && this.state.user.role === 'ADMIN' && (
                                    <Nav.Item onClick={() => this.setState({ activeMenu: 'admin' })}>
                                        <Nav.Link as={Link}
                                            className={this.state.activeMenu === 'admin' ? styles.menuItemActive : 'uxf-link-text'}
                                            to="/admin">Admin</Nav.Link>
                                    </Nav.Item>
                                )}
                                <Nav.Item>
                                    {config.isDevelopmentEnvironment && (this.state.user && this.state.user.role === 'ADMIN' &&
                                        (
                                            <FormControl style={{
                                                minWidth: 150,
                                                marginBottom: 15,
                                                marginLeft: 15,
                                                marginRight: 15
                                            }}>
                                                <InputLabel htmlFor="role-override">Role Override</InputLabel>
                                                <Select inputProps={{ name: 'role-override', id: 'role-override' }}
                                                    labelWidth={100}
                                                    onChange={({ target }) => {
                                                        AuthService.role = target.value;
                                                        location.reload();
                                                    }}
                                                    style={{ maxHeight: '2.5em' }}
                                                    value={!this.state.role || this.state.role === 'ADMIN' ? '' : this.state.role}
                                                >
                                                    <MenuItem value=""><em>None</em></MenuItem>
                                                    <MenuItem value={'ASSIGN'}>Assignment</MenuItem>
                                                    <MenuItem value={'VIEW'}>View Only</MenuItem>
                                                </Select>
                                            </FormControl>
                                        )
                                    )}
                                </Nav.Item>
                                {config.isDevelopmentEnvironment &&
                                <>
                                    <Nav.Item>
                                        <FormControlLabel
                                            control={
                                                <PaperSwitch checked={localStorage.getItem('localhost') === 'true'}
                                                    color="primary"
                                                    onChange={(e) => {
                                                        localStorage.setItem('localhost', e.target.checked);
                                                        location.reload();
                                                    }} />
                                            } label="Use Localhost" />
                                    </Nav.Item>
                                    <TranslateTab
                                        translateToEnglishSwitchHandler={this.translateToEnglishSwitchHandler}
                                        user={this.state.user}
                                    />
                                </>}
                            </Grid>
                        </AppBar>

                        <Container maxWidth="lg" style={{ paddingTop: 20 }}>
                            <Routes>
                                <Route element={
                                    (this.state.user !== null && hasAccessToProposalTrackingModule.includes(this.state.user.branchCode))
                                        ? <Navigate to='/proposal-tracking' />
                                        : ((this.state.user !== null && hasAccessToEsignatureModule.includes(this.state.user.branchCode))
                                            ? <Navigate to='/e-sign' />
                                            : <EmptyStateLayout
                                                context={<FormattedMessage id={'alerts.NO_MODULE_ASSIGNED'} />}
                                                message={<FormattedMessage id={'alerts.NO_ACCESS_TO_PROPOSAL_TRACKING_OR_ESIGN'} />} />
                                        )
                                } path="/" />


                                {this.state.user !== null && hasAccessToProposalTrackingModule.includes(this.state.user.branchCode) && (
                                    <Route element={<SearchPage />} path="/proposal-tracking" />
                                )}

                                {this.state.user !== null && this.state.user.role === 'ADMIN' && (
                                    <Route element={<AdminPage />} path="/admin" />
                                )}

                                {this.state.user !== null && this.state.user.role === 'ADMIN' && (
                                    <Route element={<AlfaUser />} path="/alfauser" />
                                )}

                                {this.state.user !== null && hasAccessToEsignatureModule.includes(this.state.user.branchCode) && (
                                    <Route element={<SelectProposalEsign bundleNumber={this.state.searchParam} location={window.location} user={this.state.user} />} path="/signBundle" />
                                )}

                                {this.state.user !== null && hasAccessToEsignatureModule.includes(this.state.user.branchCode) && (
                                    <Route element={<SelectProposalEsign agreementNumber={this.state.searchParam} location={window.location} user={this.state.user} />} path="/signAgreement" />
                                )}

                                {this.state.user !== null && hasAccessToEsignatureModule.includes(this.state.user.branchCode) && (
                                    <Route element={<EnvelopeWithLocation />} path="/e-sign/*" />
                                )}

                                {this.state.user !== null && hasAccessToEsignatureModule.includes(this.state.user.branchCode) && (
                                    <Route element={<SelectProposalEsign location={window.location} user={this.state.user} />} path="/e-sign" />
                                )}

                                {this.state.user !== null && this.state.user.hasAccessToMergerAndAcquisition && (
                                    <Route element={<DealerMerge />} path="/merge-dealers" />
                                )}

                                {this.state.user !== null && this.state.user.hasAccessToFCCMAdminUtility && (
                                    <Route element={<AdminUtility />} path="/admin-utility" />
                                )}
                            </Routes>
                        </Container>
                        <DeereFooter />
                    </Router>
                </ThemeProvider>
            </TranslationWrapper>
        );
    }
}
